import { Rotas } from './rotas'
import PrivateRoute from './privateRoute'
import DocumentManagement from 'pages/documentManagement'
import ContractTokenValidation from 'pages/simulation/formalization/permissao-token-contrato'
import ContractView from 'pages/simulation/formalization/visualizar-contrato'
import lazyWithRetry from 'utils/lazyWithRetry'

const Menu = lazyWithRetry(() => import('pages/menu'))
const Start = lazyWithRetry(() => import('pages/simulation/start'))
const Login = lazyWithRetry(() => import('pages/auth/login'))
const RecoverPassword = lazyWithRetry(() => import('pages/auth/recover-password'))
const NewPassword = lazyWithRetry(() => import('pages/auth/new-password'))
const Contracts = lazyWithRetry(() => import('pages/management/managementPage'))
const Groups = lazyWithRetry(() => import('pages/simulation/groups'))
const Products = lazyWithRetry(() => import('pages/simulation/products'))
const ProductDetail = lazyWithRetry(() => import('pages/simulation/product-detail'))
const Cart = lazyWithRetry(() => import('pages/simulation/cart'))
const ClientIdentification = lazyWithRetry(
  () => import('pages/simulation/client/client-identification')
)
const PaymentMethod = lazyWithRetry(() => import('pages/simulation/client/payment-method'))
const Documents = lazyWithRetry(() => import('pages/simulation/register/documents'))
const PaymentDevolution = lazyWithRetry(() => import('pages/simulation/payment/devolution'))
const Insurance = lazyWithRetry(() => import('pages/simulation/payment/insurance'))
const Resume = lazyWithRetry(() => import('pages/simulation/payment/resume'))
const Descontos = lazyWithRetry(() => import('pages/simulation/client/descontos'))
const ContratoDigital = lazyWithRetry(() => import('pages/simulation/formalization/contract'))
const Error = lazyWithRetry(() => import('pages/auth/error'))
const Atalho = lazyWithRetry(() => import('./atalho'))
const ContratoEnviado = lazyWithRetry(
  () => import('pages/simulation/formalization/contract-status')
)
const RegistrationForm = lazyWithRetry(() => import('pages/simulation/register/registrationForm'))
const DashboardManagement = lazyWithRetry(() => import('pages/management/dashboard'))
const AnalyticalPanelGroups = lazyWithRetry(() => import('pages/management/analyticalPanel'))
const Flexibilization = lazyWithRetry(() => import('pages/flexibilization'))
const ConfirmationContemplation = lazyWithRetry(() => import('pages/confirmationContemplation'))
const CreditLetter = lazyWithRetry(() => import('pages/creditLetter'))
const UtilizacaoCarta = lazyWithRetry(() => import('pages/utilizacaoCarta'))
const UtilizacaoConsultar = lazyWithRetry(() => import('pages/utilizacaoCarta/consultar'))
const UtilizacaoRegistro = lazyWithRetry(() => import('pages/utilizacaoCarta/registro'))
const ConsultarProcesso = lazyWithRetry(() => import('pages/utilizacaoCarta/consultarProcesso'))
const EmitirInstrumento = lazyWithRetry(() => import('pages/utilizacaoCarta/emitirInstrumento'))
const Publicity = lazyWithRetry(() => import('pages/publicity'))
const Users = lazyWithRetry(() => import('pages/users'))
const CreditStatus = lazyWithRetry(() => import('pages/simulation/formalization/creditStatus'))
const CreditStatusResultReproved = lazyWithRetry(
  () => import('pages/simulation/formalization/creditStatusResult/CreditStatusResultReproved')
)
const CreditStatusResultPending = lazyWithRetry(
  () => import('pages/simulation/formalization/creditStatusResult/CreditStatusResultPending')
)
const ContractManual = lazyWithRetry(() => import('pages/simulation/formalization/contract'))
const DocumentViewerFormalization = lazyWithRetry(
  () => import('components/Custom/DocumentViewerFormalization')
)

export type AppRouteProps = {
  path: string
  element: React.ReactElement
}

const privateRoutes: AppRouteProps[] = [
  {
    path: Rotas.INICIO,
    element: <PrivateRoute element={<Start />} />
  },
  {
    path: '/gestao/contratos',
    element: <PrivateRoute element={<Contracts />} />
  },
  {
    path: Rotas.GRUPOS,
    element: <PrivateRoute element={<Groups />} />
  },
  {
    path: Rotas.PRODUTOS,
    element: <PrivateRoute element={<Products />} />
  },
  {
    path: Rotas.DETALHE_PRODUTO,
    element: <PrivateRoute element={<ProductDetail />} />
  },
  {
    path: Rotas.CARRINHO,
    element: <PrivateRoute element={<Cart />} />
  },
  {
    path: Rotas.IDENTIFICACAO_CLIENTE,
    element: <PrivateRoute element={<ClientIdentification />} />
  },
  {
    path: Rotas.METODO_PAGAMENTO,
    element: <PrivateRoute element={<PaymentMethod />} />
  },

  {
    path: Rotas.DEVOLUCAO,
    element: <PrivateRoute element={<PaymentDevolution />} />
  },
  {
    path: Rotas.DOCUMENTOS,
    element: <PrivateRoute element={<Documents />} />
  },
  {
    path: Rotas.SEGURO,
    element: <PrivateRoute element={<Insurance />} />
  },
  {
    path: Rotas.RESUMO,
    element: <PrivateRoute element={<Resume />} />
  },
  {
    path: Rotas.DESCONTOS,
    element: <PrivateRoute element={<Descontos />} />
  },
  {
    path: Rotas.CONTRATO_DIGITAL,
    element: <PrivateRoute element={<ContratoDigital />} />
  },

  {
    path: Rotas.ROTAS,
    element: <PrivateRoute element={<Atalho />} />
  },
  {
    path: Rotas.CONTRATO_ENVIADO,
    element: <PrivateRoute element={<ContratoEnviado />} />
  },

  {
    path: Rotas.DOCUMENTACAO,
    element: <PrivateRoute element={<DocumentManagement />} />
  },
  {
    path: Rotas.REGISTRO_CLIENTE,
    element: <PrivateRoute element={<RegistrationForm />} />
  },
  {
    path: Rotas.DASHBOARD_MANAGEMENT,
    element: <PrivateRoute element={<DashboardManagement />} />
  },
  {
    path: Rotas.PAINEL_ANALITICO_GRUPOS,
    element: <PrivateRoute element={<AnalyticalPanelGroups />} />
  },
  {
    path: Rotas.FLEXIBILIZACAO,
    element: <PrivateRoute element={<Flexibilization />} />
  },
  {
    path: Rotas.CREDITO_STATUS,
    element: <PrivateRoute element={<CreditStatus />} />
  },
  {
    path: Rotas.CREDITO_STATUS_RESULT_REPROVED,
    element: <PrivateRoute element={<CreditStatusResultReproved />} />
  },
  {
    path: Rotas.CREDITO_STATUS_RESULT_PENDING,
    element: <PrivateRoute element={<CreditStatusResultPending />} />
  },
  {
    path: Rotas.CONTRATO_MANUAL,
    element: <PrivateRoute element={<ContractManual />} />
  },

  {
    path: Rotas.CONTRATO_MANUAL_DOWNLOAD,
    element: <PrivateRoute element={<DocumentViewerFormalization />} />
  },

  {
    path: Rotas.PUBLICIDADE,
    element: <PrivateRoute element={<Publicity />} />
  },
  {
    path: Rotas.USUARIOS,
    element: <PrivateRoute element={<Users />} />
  },
  {
    path: Rotas.NOVA_SENHA,
    element: <PrivateRoute element={<NewPassword />} />
  },
  {
    path: '/menu',
    element: <PrivateRoute element={<Menu />} />
  },
  {
    path: Rotas.CONFIRMATION_CONTEMPLATION,
    element: <PrivateRoute element={<ConfirmationContemplation />} />
  },
  {
    path: Rotas.CREDIT_LETTER,
    element: <PrivateRoute element={<CreditLetter />} />
  },
  {
    path: Rotas.CREDIT_CARD_USAGE,
    element: <PrivateRoute element={<UtilizacaoCarta />} />
  },
  {
    path: Rotas.CREDIT_CARD_USAGE_CONSULT,
    element: <PrivateRoute element={<UtilizacaoConsultar />} />
  },
  {
    path: Rotas.CREDIT_CARD_USAGE_REGISTER,
    element: <PrivateRoute element={<UtilizacaoRegistro />} />
  },
  {
    path: Rotas.CREDIT_CARD_USAGE_CONSULT_PROCESS,
    element: <PrivateRoute element={<ConsultarProcesso />} />
  },
  {
    path: Rotas.CREDIT_CARD_USAGE_EMITIR_INSTRUMENTO,
    element: <PrivateRoute element={<EmitirInstrumento />} />
  }
]

const publicRoutes: AppRouteProps[] = [
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: Rotas.ERROR_NOT_FOUND,
    element: <Error />
  },
  {
    path: Rotas.CONTRATO_VALIDACAO_TOKEN,
    element: <ContractTokenValidation />
  },
  {
    path: Rotas.CONTRATO_VISUALIZACAO,
    element: <ContractView />
  },
  {
    path: Rotas.RECUPERAR_SENHA,
    element: <RecoverPassword />
  }
]

export { publicRoutes, privateRoutes }
